import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/Header';
import './VerifyEmailPage.css';

const VerifyEmailPage = ({ isEmailChange = false }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Отсутствует токен верификации');
        return;
      }

      try {
        // Use different API endpoint for email change verification
        const endpoint = isEmailChange 
          ? `/auth/verify-email-change/${token}`
          : `/auth/verify-email/${token}`;
        
        const result = await verifyEmail(token);
        
        if (result.success) {
          setStatus('success');
          setMessage(result.message || 'Email успешно подтвержден!');
          
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/auth');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(result.error || 'Ошибка при подтверждении email');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Произошла ошибка. Попробуйте позже.');
      }
    };

    verify();
  }, [token, isEmailChange, verifyEmail, navigate]);

  return (
    <div className="verify-email-page">
      <Header activeNav="auth" />
      
      <main className="verify-email-page__main">
        <div className="verify-email-page__container">
          <div className="verify-email-page__card">
            {status === 'loading' && (
              <>
                <div className="verify-email-page__spinner" />
                <h2 className="verify-email-page__title">Подтверждение email...</h2>
                <p className="verify-email-page__text">Пожалуйста, подождите</p>
              </>
            )}
            
            {status === 'success' && (
              <>
                <div className="verify-email-page__icon verify-email-page__icon--success">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h2 className="verify-email-page__title">{message}</h2>
                <p className="verify-email-page__text">
                  Вы будете перенаправлены на страницу входа через несколько секунд...
                </p>
                <Link to="/auth" className="verify-email-page__button">
                  Войти сейчас
                </Link>
              </>
            )}
            
            {status === 'error' && (
              <>
                <div className="verify-email-page__icon verify-email-page__icon--error">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M15 9l-6 6M9 9l6 6" strokeLinecap="round"/>
                  </svg>
                </div>
                <h2 className="verify-email-page__title">Ошибка</h2>
                <p className="verify-email-page__text">{message}</p>
                <Link to="/auth" className="verify-email-page__button">
                  Вернуться к авторизации
                </Link>
              </>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default VerifyEmailPage;

